import { css } from 'astroturf';
import React, { useEffect } from 'react';
import { Download } from 'react-bytesize-icons';

const styles = css`
  .collection {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    padding: 1rem 0;
    border-radius: 8px;
    background: #fff;
    box-shadow:
      0 0 0 1px rgba(0, 0, 0, 0.024),
      0 1px 0 rgba(0, 0, 0, 0.05),
      0 0 8px rgba(0, 0, 0, 0.03),
      0 20px 30px rgba(0, 0, 0, 0.1);

    .heading {
      margin: 0;
      display: flex;
      align-items: center;
      gap: 0.75rem;

      button {
        margin-left: auto;
      }
    }

    h3 {
      margin: 0;
      font-size: 1.25rem;
      font-weight: 600;
      line-height: 35px;
      color: #0a1530;
    }

    .heading svg {
      color: #39728d;
    }

    .clear {
      border: 0;
      background: none;
      color: #39728d;
      font-weight: 700;
      font-size: 12px;
      cursor: pointer;
      padding: 0;
      width: auto;

      &:hover,
      &:focus-visible {
        background: none;
        color: #0a1530;
      }

      &:disabled {
        color: #98a0ac;
        cursor: default;
      }
    }

    p,
    label {
      color: #0a1530;
      font-size: 0.875rem;
      font-weight: 500;
    }

    .snippetHeader {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 0.5rem;

      p {
        margin: 0;
      }
    }

    .snippetToggle {
      display: none;
      border: 0;
      background: none;
      color: #39728d;
      font-weight: 700;
      font-size: 0.75rem;
      cursor: pointer;
      padding: 0;
      width: auto;

      &:hover,
      &:focus-visible {
        background: none;
        color: #0a1530;
      }
    }

    input {
      font-size: 1rem;
      width: 100%;
      padding: 0.7rem 0.8rem;
      border: 1px solid #d7d7d7;
      border-radius: 4px;
      margin: 0;
    }

    textarea {
      font-size: 1rem;
      width: 100%;
      padding: 0.7rem 0.8rem;
      border: 1px solid #d7d7d7;
      border-radius: 4px;
      margin: 0;
      min-height: 84px;
      resize: vertical;
      font-family: inherit;
    }

    ul {
      margin: 0;
      padding-left: 0;
      list-style: none;
      max-height: 320px;
      overflow: auto;
      border: 1px solid #d9dde7;
      border-radius: 6px;
      background: #00aeff11;
      padding: 0rem 0.75rem;
    }

    li {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 0.75rem;
      border-top: 1px solid #eee;
      padding: 0.4rem 0;

      &:first-child {
        border-top: 0;
      }

      .itemMain {
        min-width: 0;
        display: inline-flex;
        align-items: center;
        gap: 0.45rem;
      }

      .itemBadge {
        width: 18px;
        height: 14px;
        display: flex;
        align-items: flex-end;
        justify-content: flex-end;
        border-radius: 3px;
        padding: 1px 2px;
        font-size: 7px;
        font-weight: 600;
        line-height: 1;
        letter-spacing: 0;
        text-transform: uppercase;
        text-align: end;
        background: var(--background);
        color: var(--text-color-secondary);
        flex-shrink: 0;

        &.itemBadgeCss {
          background: rebeccapurple;
          color: white;
        }

        &.itemBadgeJs,
        &.itemBadgeJavascript {
          background: #f7df1e;
          color: #000;
        }
      }

      .itemInfo {
        display: flex;
        flex-direction: column;
        min-width: 0;
        font-size: 0.875rem;
        font-weight: 700;
        color: #1f293d;
        line-height: 1;
      }

      .itemDesc {
        padding-top: 0.125rem;
        font-size: 0.75rem;
        line-height: 1.25;
        font-weight: 400;
        color: #6a7382;
        line-clamp: 2;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }

    .itemRemove {
      border: 0;
      background: #0000;
      color: #6a7382;
      width: 1.9rem;
      height: 1.9rem;
      border-radius: 4px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      flex: 0 0 auto;
      transition:
        0.15s ease-in-out background,
        0.15s ease-in-out color;

      &:hover,
      &:focus-visible {
        background: #0001;
        color: #1f293d;
      }

      svg {
        width: 15px;
        height: 15px;
      }
    }

    .collectionActions {
      display: grid;

      input {
        margin: 0;
      }

      button {
        border: 0;
        border-radius: 4px;
        padding: 0.65rem 0.85rem;
        font-weight: 600;
        cursor: pointer;
        width: 100%;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 0.35rem;
        line-height: 1;
        margin-top: 1rem;
        font-size: 0.875rem;
      }

      .download svg {
        width: 14px;
        height: 14px;
        stroke-width: 3px;
      }

      .moreToggle {
        width: auto;
        justify-self: end;
        margin-top: 0.5rem;
        margin-bottom: 0.25rem;
        padding: 0;
        border: 0;
        border-radius: 0;
        background: none;
        color: #39728d;
        font-weight: 400;
        font-size: 0.75rem;
        line-height: 1.1;

        &:hover,
        &:focus-visible {
          background: none;
          color: #0a1530;
        }
      }
    }
  }

  @media (max-width: 40rem) {
    .collection {
      .heading {
        position: sticky;
        top: 0;
        z-index: 2;
        background: #fff;
        padding: 0.5rem 0;
      }

      .snippetToggle {
        display: inline-flex;
      }
    }
  }

  .download {
    background: #107db5;
    color: #fff;
    transition: 0.15s ease-in-out background;
    &:hover,
    &:focus-visible {
      background: #008300;
    }
  }

  .empty {
    padding: 0.2rem 0.4rem;
    background: none;
    border-radius: 0;
    color: #666;
  }
`;

function normalizeType(language) {
  return language === 'javascript' ? 'js' : 'css';
}

function TrashIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <path d="M3 6h18" />
      <path d="M8 6V4h8v2" />
      <path d="M19 6l-1 14H6L5 6" />
      <path d="M10 11v6" />
      <path d="M14 11v6" />
    </svg>
  );
}

export default function CollectionPanel({
  title,
  author,
  description,
  onTitleChange,
  onAuthorChange,
  onDescriptionChange,
  snippets,
  onDownload,
  onRemove,
  onClear,
  className,
  buildCollectionFolder,
}) {
  const [showMore, setShowMore] = React.useState(false);
  const [isCompact, setIsCompact] = React.useState(false);
  const [showSnippetList, setShowSnippetList] = React.useState(true);

  const handleClose = () => {
    setShowMore(false);
    onClear();
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    onDownload();
  };

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 40rem)');

    const handleMediaChange = (event) => {
      setIsCompact(event.matches);
      setShowSnippetList(!event.matches);
    };

    handleMediaChange(mediaQuery);
    mediaQuery.addEventListener('change', handleMediaChange);

    return () => {
      mediaQuery.removeEventListener('change', handleMediaChange);
    };
  }, []);

  const jsonData = buildCollectionFolder(title || 'Snippet collection', snippets, description, author);

  return (
    <section className={[styles.collection, className].filter(Boolean).join(' ')}>
      <div className={styles.heading}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="icon icon-tabler icons-tabler-outline icon-tabler-folder-open"
        >
          <path d="M5 19l2.757 -7.351a1 1 0 0 1 .936 -.649h12.307a1 1 0 0 1 .986 1.164l-.996 5.211a2 2 0 0 1 -1.964 1.625h-14.026a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v2" />
        </svg>
        <h3>Create collection</h3>
        <button className={styles.clear} type="button" onClick={handleClose} disabled={!snippets.length}>
          Close
        </button>
      </div>
      <div className={styles.snippetHeader}>
        <p>Selected snippets ({snippets.length})</p>
        {snippets.length ? (
          <button
            className={styles.snippetToggle}
            type="button"
            onClick={() => setShowSnippetList((current) => !current)}
          >
            {showSnippetList ? 'Collapse' : 'Expand'}
          </button>
        ) : null}
      </div>
      {snippets.length && (!isCompact || showSnippetList) ? (
        <ul>
          {snippets.map((snippet) => (
            <li key={snippet.id}>
              <div className={styles.itemMain}>
                <span
                  className={[
                    styles.itemBadge,
                    normalizeType(snippet.language) === 'js' ? styles.itemBadgeJs : styles.itemBadgeCss,
                  ].join(' ')}
                >
                  {normalizeType(snippet.language)}
                </span>
                <span className={styles.itemInfo}>
                  <span className={styles.itemName}>{snippet.name}</span>
                  {snippet.description ? <span className={styles.itemDesc}>{snippet.description}</span> : null}
                </span>
              </div>
              <button
                className={styles.itemRemove}
                type="button"
                onClick={() => onRemove(snippet.id)}
                aria-label="Remove snippet"
                data-tip="Remove snippet"
              >
                <TrashIcon />
              </button>
            </li>
          ))}
        </ul>
      ) : (
        <div className={styles.empty}>No snippets selected yet.</div>
      )}

      <form className={styles.collectionActions} onSubmit={handleSubmit} data-card="collection">
        <label htmlFor="collection-title">Folder name</label>
        <input
          className={styles.titleInput}
          type="text"
          id="collection-title"
          value={title}
          onChange={(event) => onTitleChange(event.target.value)}
          placeholder="Snippets collection"
        />
        <button className={styles.moreToggle} type="button" onClick={() => setShowMore((current) => !current)}>
          {showMore
            ? 'Hide details'
            : author || description
              ? 'Edit author and description'
              : 'Set author and description'}
        </button>
        {showMore ? (
          <>
            <label htmlFor="collection-author">Author</label>
            <input
              className={styles.titleInput}
              type="text"
              id="collection-author"
              value={author}
              onChange={(event) => onAuthorChange(event.target.value)}
              placeholder="Collection author"
            />
            <label htmlFor="collection-description">Description</label>
            <textarea
              id="collection-description"
              value={description}
              onChange={(event) => onDescriptionChange(event.target.value)}
              placeholder="Collection description"
            />
          </>
        ) : null}
        <pre hidden>{JSON.stringify(jsonData[0])}</pre>
        <button className={styles.download} type="submit" disabled={!snippets.length} data-action="download-snippet">
          <span>Download</span> collection
          <Download />
        </button>
      </form>
    </section>
  );
}
